<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Table ref="table" :tableData="tableData" :cols="cols" :btns="btns" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'poolrecord',
      getListUrl: 'moneyrec',
      breadcrumb: [
        { name: "财务管理", path: "/finance/stabilizationFund" },
        { name: "稳定基金管理", path: "/finance/stabilizationFund" },
        { name: "提取记录" },
      ],
      cols: [
        { keyName: "name", label: "司机姓名" },
        { keyName: "getmoney", label: "提取金额" },
        { keyName: "addtime", label: "提取时间" },
      ],
      baseParams: ['driverid'],
    };
  },
  methods: {},
  mounted() {
    this.setQueryParams();
    this.$nextTick(this.getList);
  },
};
</script>
